<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'faqs' }"
          >Faqs</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <v-row no-gutters>
        <v-col cols="12" sm="8" flex>
          <div
            class="display-2 font-weight-light mb-10 font-serif text-capitalize"
          >
            Edit FAQ
          </div>
        </v-col>
        <v-col cols="12" sm="4" flex class="text-right">
          <block-form :faq="faq" />
        </v-col>
      </v-row>

      <faq-form ref="faqForm" :faq="faq" />
    </div>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mdiChevronLeft } from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import FaqForm from '@/views/Home/Faqs/components/FaqForm'
import BlockForm from '@/views/Home/Faqs/components/BlockForm'

export default {
  name: 'FaqDetails',

  components: {
    FaqForm,
    BlockForm,
    AppBarNavIcon
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft
      },
      loading: false
    }
  },

  computed: {
    ...mapState({
      faq: state => state.faq.faqDetails
    })
  },

  watch: {
    $route() {
      this.getFaq()
    }
  },

  methods: {
    ...mapActions({
      getFaqDetails: 'faq/getFaqDetails'
    }),

    ...mapMutations({
      clearFaqDetails: 'faq/clearFaqDetails'
    }),

    async getFaq() {
      this.loading = true
      await this.getFaqDetails(this.$route.params.id)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          if (error.response && error.response.status === 404) {
            this.$refs.faqForm.showSnackbar(
              'Fail to fetch faq details! FAQ may be invalid or does not exist anymore',
              'danger'
            )
          } else {
            this.$refs.faqForm.showSnackbar(
              error.response.data.message,
              'danger'
            )
          }

          this.loading = false
        })
    }
  },

  created() {
    this.getFaq()
  },

  destroyed() {
    this.clearFaqDetails()
  }
}
</script>
